/**
 * @generated SignedSource<<9f0fd8dc38f38e3380e76ec8ad85d695>>
 * @relayHash 25d9d5a89484a8d260e1431a6149ac96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cdd0810d591cb2b8f3e3f52882cb0545f46ed94291207778655ac21ab117788f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery } from './mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery.graphql';

const node: PreloadableConcreteRequest<mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cdd0810d591cb2b8f3e3f52882cb0545f46ed94291207778655ac21ab117788f",
    "metadata": {},
    "name": "mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
